export class Product {
  productCode: string = "";
  productDisplayName: string = "";
  coverDurationMonths: number = 0;
  rentalAmount: number = 0;
  total: number = 0;
  ipt: number = 0;
  nett: number = 0;
  exclusivityGroup: string = "";
}
